export default __webpack_public_path__ + "static/traffic-lead-3-35023d9b8fa58e958e1bb058c99f6b97.jpg";